/* eslint-disable no-dupe-keys */
export default {
  work_order: {
    name: '工单',
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '工单号',
      title: '标题',
      work_order_type: '工单类型',
      content: '问题描述',
      ev_charging_station: '充电站',
      ev_charging_pile: '充电桩',
      ev_charging_gun: '充电枪',
      assignee: '指派人',
      reporter: '报告人',
      status: '工单状态',
      completed_time: '处理完成时间',
      created_at: '创建时间',
      updated_at: '更新时间',
      latest_transition: '最近审核记录',
      images: '图片',
      work_order_source: '工单来源',
      priority: '优先级',
      bill_payment_type: '支付方式',
      inspection_fee: '检查费',
      labor_fee: '工时费',
      material_fee: '配件费',
      man_hour: '修复工时',
      expected_repair_date: '期望修复时间',
      total_repair_fee: '总费用',
      payment_status: '支付状态',
      latest_comment: '最新备注',
      is_warranty_expired: '桩是否过保',
      is_alarm: '是否有告警',
      referable_type: '关联信息类型',
      discount: '优惠金额',
      fee_note: '费用描述',
      // 非对象属性
      service_provider: '运营商',
      transition_description: '处理备注',
      description: '说明',
      review_desc: '审核备注',
      alarm_title: '告警内容',
      warranty: '桩保情况',
      comment: '备注',
      sms_notification: '短信通知',
      charge_point_status: '充电桩状态',
      charger_status: '充电枪状态',
      charge_station_status: '充电站状态',
      content: '内容',
      caues: '原因',
      fee: '费用',
      fee_info: '费用信息',
      sp_balance: '运营商余额',
      alarm_and_charger_status: '告警/桩状态',
      alarm: '告警',
      charger: '充电桩',
      last_trigger_at: '最近触发',
      paid_at: '支付时间'
    },
    // Enum的属性
    work_order_types: {
      fault: '故障'
    },
    is_alarms: {
      true: '是',
      false: '否'
    },
    is_warranty_expired: {
      true: '是',
      false: '否'
    },
    statuses: {
      open: '未处理',
      processing: '处理中',
      resolved: '已处理',
      closed: '已关闭'
    },
    work_order_sources: {
      from_service_provider: '运营商',
      from_platform: '系统',
      from_user: '用户'
    },
    payment_statuses: {
      paid: '已支付',
      unpaid: '未支付'
    },
    priorities: {
      low: '低',
      medium: '普通',
      high: '高',
      highest: '紧急'
    },
    bill_payment_types: {
      offline_pay: '线下支付',
      pay_with_sp_balance: '运营商余额支付'
    },
    transitions: {
      process: '开始跟进',
      resolve: '修理完成',
      terminate_close: '终止维修',
      close: '不需要处理',
      reopen: '重新打开'
    },
    referable_types: {
      alarm: '告警',
      null: '无'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询工单号/标题/问题描述',
      search_ev_charging_gun: '查询充电桩',
      input_review_desc: '说明',
      input_comment: '备注',
      is_alarm: '有告警/无告警',
      is_warranty_expired: '有质保/无质保',
      select_alarm: '请选择告警',
      select_ev_charging_pile: '请选择充电桩',
      select_ev_charging_gun: '请选择充电枪',
      closed_content: '不需要处理/重复提交/无法重现/'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    list_tabs: {
      all: '全部',
      open: '未处理',
      processing: '处理中',
      resolved: '已处理',
      closed: '已关闭',
      paid: '已支付'
    },
    // 标题
    titles: {
      relevance_info: '工单关联信息',
      base_info: '基本信息',
      change_state: '审核提示',
      content: '问题描述',
      comments: '备注信息',
      work_order_mark: '工单标记为',
      fee_info: '费用信息',
      status_info: '状态信息'
    },
    btns: {
      comment: '添加备注',
      fee: '登记费用',
      pay_fee: '支付费用'
    },
    others: {
      added_comment_at: '添加于 {0}',
      edited_comment_at: '编辑于 {0}',
      alarm_trigger_count: '触发 {0} 次',
      duration_at: '持续 {0}',
      mark_as: '标记为{0}'
    },
    tips: {
      closed_content: '确定该工单不需要处理？关闭的工单无需收取任何费用',
      payment_success: '工单扣费成功',
      offline_pay: '线下支付需要上传交易单号 或 支付记录到工单，请在下面的备注/图片中上传'
    }
  }
}
